import get from "lodash/get";

export default function getPlayInitialAd(state) {
  return (
    !!get(state, "story.ads.initial", false) ||
    !!state.playerOptions.forceInitialAd
  );
}
